import React from 'react';
import { connect } from 'react-redux';

const FullAddressAccessor = ({ slug, mainDomain }) => (
  <div>{`https://${mainDomain}/${slug.slug}`}</div>
);

export default connect(
  ({
    Brands: {
      brand: { mainDomain },
    },
  }) => ({
    mainDomain,
  })
)(FullAddressAccessor);
